import r, { OPTIONS as z } from "../managers/braze-instance.js";
import na from "./push-manager.js";
var ra = {
  i: !1,
  aa: null,
  ea: function ea() {
    return ra.t(), ra.aa || (ra.aa = new na(r.gr(), r.ba(), r.de(), r.V(), r.ee(z.Ma), r.ee(z._a), r.ee(z.ka), r.l(), r.ee(z.qa), r.ee(z.Aa), r.p())), ra.aa;
  },
  t: function t() {
    ra.i || (r.g(ra), ra.i = !0);
  },
  destroy: function destroy() {
    ra.aa = null, ra.i = !1;
  }
};
export default ra;